import validate from "/var/jenkins_home/workspace/picmastudio-web-2/node_modules/.pnpm/registry.npmmirror.com+nuxt@3.9.1_rollup@4.9.4_sass@1.69.7_vite@5.0.11/node_modules/nuxt/dist/pages/runtime/validate.js";
import default_45global from "/var/jenkins_home/workspace/picmastudio-web-2/middleware/default.global.ts";
import manifest_45route_45rule from "/var/jenkins_home/workspace/picmastudio-web-2/node_modules/.pnpm/registry.npmmirror.com+nuxt@3.9.1_rollup@4.9.4_sass@1.69.7_vite@5.0.11/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  default_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}